import type { Persistor } from "redux-persist"

let _persistor: Persistor | null = null

export function setPersistor(persistor: Persistor): void {
  _persistor = persistor
}

export function getPersistor(): Persistor {
  if (!_persistor) {
    throw new Error(
      "Persistor has not been set. Call setPersistor() in app entry.",
    )
  }
  return _persistor
}
